/* eslint-disable max-len, no-await-in-loop, no-new, no-unused-vars, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  workorderOpportunityBriefs: [],
};

export const actions = {
  async getWorkorderOpportunityBriefs({ commit }) {
    await api.get('/opportunity/workorderbriefs').then(async (response) => {
      commit('SET_WORKORDER_OPPORTUNITY_BRIEFS', response.data);
    }).catch((exception) => {
      console.error(exception);
      commit('SET_WORKORDER_OPPORTUNITY_BRIEFS', []);
      commit('SET_SERVER_ERROR', exception);
    });
  },
};

export const mutations = {
  SET_WORKORDER_OPPORTUNITY_BRIEFS(state, data) {
    state.workorderOpportunityBriefs = data;
  },
};
